export default __webpack_public_path__ + "static/media/Wazdan.c1f0cc17.png";